import React, { FunctionComponent, createContext, useContext } from 'react';
import { VPMerchantClient } from '../../lib/api-clients/VPMerchantClient';
import { useIdentityContext } from '../IdentityContext';

const BASE_URL = 'https://vpmerchant.dsp.dst.vpsvc.com/v1';

interface VPMerchantClientProviderProps {
    tenant: string;
    requestor: string;
    children: React.ReactNode;
}

const VPMerchantContext = createContext<VPMerchantClient | undefined>(undefined);

export const VPMerchantClientProvider: FunctionComponent<VPMerchantClientProviderProps> = ({
    tenant,
    requestor,
    children,
}) => {
    const { accessToken } = useIdentityContext();
    const vpMerchantClient = new VPMerchantClient({
        baseUrl: BASE_URL,
        tenant,
        requestor,
        accessToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return (
        <VPMerchantContext.Provider value={vpMerchantClient}>{children}</VPMerchantContext.Provider>
    );
};

export const useVPMerchantClient = (): VPMerchantClient => {
    const context = useContext(VPMerchantContext);
    if (!context) {
        throw new Error('useVPMerchantClient must be used within a VPMerchantClientProvider');
    }
    return context;
};
